var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"router-link",attrs:{"active-class":"active-class","to":`/${_vm.routingTo}`}},[_c('div',{staticClass:"menu-element"},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(" "+_vm._s(_vm.logoName)+" ")]),_vm._v(" "+_vm._s(_vm.content)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }